export default __webpack_public_path__ + "static/media/rent_payments.1cdcf557.png";